import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Увеличьте ваш лимит!',
  action: 'Подробнее',
} satisfies TMessages
